import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setCollapseClient } from 'redux/actions/notificationReviewActions';

import { ReactComponent as AngleArrowRightIcon } from 'assets/icon-angle-right.svg';
import { ReactComponent as AngleArrowLeftIcon } from 'assets/icon-angle-left.svg';

import { setShowTypeNotifications } from 'redux/actions/notificationActions';
import { CollapseClient, Individual, Massive } from './styles';

import { ClientPanelBackground, CollapseClientRight } from '../styles';

const ContactPanel = () => {
  const dispatch = useDispatch();
  const { isCollapse } = useSelector((state) => state.notificationReview);
  const { showTypeNotifications } = useSelector((state) => state.notification);
  const { t } = useTranslation();

  return (
    <>
      {!isCollapse ? (
        <ClientPanelBackground className="mr-4">
          <div className="d-flex justify-content-end">
            <CollapseClient onClick={() => dispatch(setCollapseClient(true))}>
              <AngleArrowLeftIcon />
            </CollapseClient>
          </div>
          <hr />
          <Individual
            onClick={() => {
              dispatch(setShowTypeNotifications(false));
            }}
            showTypeNotifications={showTypeNotifications}
          >
            <span>{t('notifications_text_personals')}</span>
          </Individual>
          <Massive
            onClick={() => {
              dispatch(setShowTypeNotifications(true));
            }}
            showTypeNotifications={showTypeNotifications}
          >
            <span>{t('notifications_text_diffusion')}</span>
          </Massive>
        </ClientPanelBackground>
      ) : (
        <div className="collapse-client-container mr-3">
          <CollapseClientRight onClick={() => dispatch(setCollapseClient(false))}>
            <AngleArrowRightIcon />
          </CollapseClientRight>
        </div>
      )}
    </>
  );
};

ContactPanel.defaultProps = {};

ContactPanel.propTypes = {};

export default ContactPanel;
